<script>
  import Router from 'svelte-spa-router';

  import Home from './pages/Home.svelte';
  import ArticlesWrapper from './pages/ArticlesWrapper.svelte';
  import ArticlesArticleWrapper from './pages/ArticlesArticleWrapper.svelte';
  import ScheduleAndResultsWrapper from './pages/ScheduleAndResultsWrapper.svelte';
  import GamesGameWrapper from './pages/GamesGameWrapper.svelte';
  import StandingsWrapper from './pages/StandingsWrapper.svelte';
  import StatisticsWrapper from './pages/StatisticsWrapper.svelte';
  import StatisticsType from './pages/StatisticsType.svelte';
  import Teams from './pages/Teams.svelte';
  import TeamsTeamWrapper from './pages/TeamsTeamWrapper.svelte';
  import Fields from './pages/Fields.svelte';
  import FieldsFieldWrapper from './pages/FieldsFieldWrapper.svelte';
  import Tickets from './pages/Tickets.svelte';
  import History from './pages/History.svelte';
  import ForPress from './pages/ForPress.svelte';
  import Information from './pages/Information.svelte';
  import PreparatoryGames from './pages/PreparatoryGames.svelte';
  import RocketHand from './pages/RocketHand.svelte';
  import AdminArticlesArticle from './pages/admin/AdminArticlesArticle.svelte';
  import AdminTweetsTweet from './pages/admin/AdminTweetsTweet.svelte';
  import AdminTeamsTeam from './pages/admin/AdminTeamsTeam.svelte';
  import AdminFieldsField from './pages/admin/AdminFieldsField.svelte';
  import AdminGamesGame from './pages/admin/AdminGamesGame.svelte';
  import AdminPressReleasesPressRelease from './pages/admin/AdminPressReleasesPressRelease.svelte';
  import AdminDailyBulletinsDailyBulletin from './pages/admin/AdminDailyBulletinsDailyBulletin.svelte';
  import AdminPagesPage from './pages/admin/AdminPagesPage.svelte';
  import AdminImportantLinks from './pages/admin/AdminImportantLinks.svelte';
  import AdminLinks from './pages/admin/AdminLinks.svelte';
  import AdminPartners from './pages/admin/AdminPartners.svelte';
  import AdminAccompanyingEvents from './pages/admin/AdminAccompanyingEvents.svelte';
  import AdminScheduleAndResultsImportantLinks from './pages/admin/AdminScheduleAndResultsImportantLinks.svelte';
  import AdminTickets from './pages/admin/AdminTickets.svelte';
  import AdminForPressContacts from './pages/admin/AdminForPressContacts.svelte';
  import AdminForPressImportantLinks from './pages/admin/AdminForPressImportantLinks.svelte';
  import AdminInformationContacts from './pages/admin/AdminInformationContacts.svelte';
  import AdminInformationImportantLinks from './pages/admin/AdminInformationImportantLinks.svelte';
  import AdminOfficials from './pages/admin/AdminOfficials.svelte';
  import AdminPreparatoryGames from './pages/admin/AdminPreparatoryGames.svelte';
  import AdminTitlePhoto from './pages/admin/AdminTitlePhoto.svelte';
  import AdminUploadPhoto from './pages/admin/AdminUploadPhoto.svelte';
  import AdminUploadImage from './pages/admin/AdminUploadImage.svelte';
  import AdminUploadFile from './pages/admin/AdminUploadFile.svelte';
  import Login from './pages/Login.svelte';
  import Logout from './pages/Logout.svelte';
  import ChangePassword from './pages/ChangePassword.svelte';
  // import ResetPassword from './pages/ResetPassword.svelte';

  import NotFound from './pages/NotFound.svelte';

  const routes = {
    '/': Home,
    '/home': Home,
    '/articles': ArticlesWrapper,
    '/articles/find/:find': ArticlesWrapper,
    '/articles/:article': ArticlesArticleWrapper,
    '/schedule-and-results': ScheduleAndResultsWrapper,
    '/schedule-and-results/:year': ScheduleAndResultsWrapper,
    '/games/:game': GamesGameWrapper,
    '/games/:game/:year': GamesGameWrapper,
    '/standings': StandingsWrapper,
    '/standings/:year': StandingsWrapper,
    '/statistics': StatisticsWrapper,
    '/statistics/:year': StatisticsWrapper,
    '/statistics/:year/:type': StatisticsType,
    '/teams': Teams,
    '/teams/:team': TeamsTeamWrapper,
    '/teams/:team/:year': TeamsTeamWrapper,
    '/teams/:team/:year/:section': TeamsTeamWrapper,
    '/fields': Fields,
    '/fields/:field': FieldsFieldWrapper,
    '/fields/:field/:year': FieldsFieldWrapper,
    '/fields/:field/:year/:section': FieldsFieldWrapper,
    '/tickets': Tickets,
    '/history': History,
    '/for-press': ForPress,
    '/information': Information,
    '/preparatory-games': PreparatoryGames,
    '/rocket-hand': RocketHand,
    '/admin/articles/:article': AdminArticlesArticle,
    '/admin/tweets/:tweet': AdminTweetsTweet,
    '/admin/teams/:team': AdminTeamsTeam,
    '/admin/fields/:field': AdminFieldsField,
    '/admin/games/:game': AdminGamesGame,
    '/admin/games/:game/:year': AdminGamesGame,
    '/admin/press-releases/:pressRelease': AdminPressReleasesPressRelease,
    '/admin/daily-bulletins/:dailyBulletin': AdminDailyBulletinsDailyBulletin,
    '/admin/pages/:page': AdminPagesPage,
    '/admin/important-links': AdminImportantLinks,
    '/admin/links': AdminLinks,
    '/admin/partners': AdminPartners,
    '/admin/accompanying-events': AdminAccompanyingEvents,
    '/admin/schedule-and-results-important-links': AdminScheduleAndResultsImportantLinks,
    '/admin/tickets': AdminTickets,
    '/admin/for-press-contacts': AdminForPressContacts,
    '/admin/for-press-important-links': AdminForPressImportantLinks,
    '/admin/information-contacts': AdminInformationContacts,
    '/admin/information-important-links': AdminInformationImportantLinks,
    '/admin/officials': AdminOfficials,
    '/admin/preparatory-games': AdminPreparatoryGames,
    '/admin/title/:photo': AdminTitlePhoto,
    '/admin/upload/photo': AdminUploadPhoto,
    '/admin/upload/image': AdminUploadImage,
    '/admin/upload/file': AdminUploadFile,
    '/login': Login,
    '/login/:failure': Login,
    '/logout': Logout,
    '/change-password': ChangePassword,
    // '/reset-password': ResetPassword,

    '*': NotFound,
  };
</script>

<Router {routes}/>
